export enum EnumSituacaoPessoa {
    Ativo = 0,
    Inativo = 1,
    Inadimplente = 2,
}